import { createContext } from 'react';

export interface SiteContextState {
  siteId: string;
  setSiteId: (siteId: string) => Promise<void>;
  canChangeSite: boolean;
}

export const SiteContext = createContext<SiteContextState | null>(null);
